<template>
  <section class="section">
    <div class="container mb-5">
      <div class="intro column is-8 is-offset-2">
        <h2 class="title has-text-centered">
          ¿Cansado de bajar información de portales web o de leer documentación
          de API de tus servicios?
        </h2>
        <br />
        <p class="subtitle">
          Connect permite olvidarte de la integración de los datos basada en
          planillas excel para pasar a realizar análisis que te permitan tomar
          decisiones utilizando datos consolidados.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "TopMessage",
};
</script>

<style lang="scss" scoped></style>
